
export function deleteDocs(ids: string | string[]) {
  return (dispatch: any, getState: any) => {
    const { auth } = getState();
    dispatch({ type: DELETE_DOC_REQUEST });

    const isArray = Array.isArray(ids);

    const url = isArray ? `/api/documents` : `/api/documents/${ids}`;
    const options: RequestInit = {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      ...(isArray ? { body: JSON.stringify({ ids }) } : {}),
    };

    return fetch(url, options).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({ type: DELETE_DOC_SUCCESS, payload: data.result });
      } else {
        dispatch({ type: DELETE_DOC_FAILURE, payload: data });
      }
    });
  };
}

export const DELETE_DOC_REQUEST = "Delete.Doc.Request";
export const DELETE_DOC_SUCCESS  = "Delete.Doc.Success";
export const DELETE_DOC_FAILURE  = "Delete.Doc.Failure";
export const DELETE_DOC_RESET = "Delete.Doc.Reset";


